import React, { useState } from "react";
import "./Profile.scss";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import profilepic from "../../../assets/images/profilepic.png";

function MyVerticallyCenteredModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-titlevcenter">
          <div className="curentpic">
            <img src={profilepic} alt="" />
            <p>Current Photo</p>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="uploadpic">
          <p>Upload Photo</p>
        </div>
      </Modal.Body>
      <div className="removepic">
        <p>Remove Photo</p>
      </div>

      <Modal.Footer>
        <Button onClick={props.onHide}>Cancel</Button>
      </Modal.Footer>
    </Modal>
  );
}

const EditProfile = () => {
  const [modalShow, setModalShow] = useState(false);
  const [bioText, setBioText] = useState("");
  const [activeSection, setActiveSection] = useState("Personal Information");

  const handleBioChange = (event) => {
    const newText = event.target.value;
    // Check if the text exceeds 200 words
    if (newText.split(/\s+/).filter((word) => word !== "").length <= 200) {
      setBioText(newText);
    }
  };

  const countWords = () => {
    const words = bioText.split(/\s+/).filter((word) => word !== "");
    return words.length;
  };
  const remainingWords = 200 - countWords();

  return (
    <div className="customScroller-transparent">
    <div className="edit ">
     
      <div className="editbot">
        <div className="editbotleft">
        <div className="edittop">
        <h1>
            Edit Profile
          </h1>
        </div>
        <div className="perinfo">
          <h2
            onClick={() => setActiveSection("Personal Information")}
            className={activeSection === "Personal Information" ? "active" : ""}
          >
            Personal Information
          </h2>
          <h2
            onClick={() => setActiveSection("Address")}
            className={activeSection === "Address" ? "active" : ""}
          >
            Address
          </h2>
          <h2
            onClick={() => setActiveSection("Social Media")}
            className={activeSection === "Social Media" ? "active" : ""}
          >
            Social media accounts
          </h2>
        </div>
        </div>
        <div className="editleft">
          <div className="updatebtn">
            <p>Update</p>
          </div>
          <div className="editleftcontent">
        {activeSection === "Personal Information" && (
          <div className="infodetail">
            <div className="changeprofile">
              <div className="changeleft">
                <h2>Jack Adoms</h2>
                <p onClick={() => setModalShow(true)}>
                  Change Profile picture
                </p>
              </div>
              <div
                className="modal show"
                style={{ display: "block", position: "initial" }}
              >
                <MyVerticallyCenteredModal
                  show={modalShow}
                  onHide={() => setModalShow(false)}
                />
              </div>
              <div className="changeright">
                <img src={profilepic} alt="" />
              </div>
            </div>
            <div className="fname pt-4">
              <div className="nameleft">
                <p>First Name</p>
              </div>
              <div className="nameright">
                <input type="Jack" placeholder="Jack" />
              </div>
            </div>
            <div className="fname lastname">
              <div className="nameleft">
                <p>Last Name</p>
              </div>
              <div className="nameright">
                <input type="Jack" placeholder="Adoms" />
              </div>
            </div>
            <div className="fname pt-4">
              <div className="nameleft">
                <p>Email</p>
              </div>
              <div className="nameright">
                <input
                  type="Jack"
                  placeholder="jackadmos@gmail.com"
                />
              </div>
            </div>
            <div className="fname pt-4">
              <div className="nameleft">
                <p>Phone </p>
              </div>
              <div className="nameright">
                <input type="Jack" placeholder="(213) 555-1239" />
              </div>
            </div>
            <div className="biography">
              <div className="bioleft">
                <h2>Your bio</h2>
                <p>Write a short introduction</p>
              </div>
              <div className="bioright">
                <select
                  className="form-select form-select-sm"
                  aria-label=".form-select-sm example"
                >
                  <option selected>
                    <p>Regular</p>
                  </option>
                </select>
                <div className="biorighttext">
                  <textarea
                    cols="50"
                    rows="7"
                    placeholder="Pellentesque dictum elit sapien, eu 
                    pharetra massa pretium eu. Integer 
                    feugiat aliquet augue, ac congue 
                    ligula posuere nec. Phasellus eget 
                    vulputate erat. Suspendisse et 
                    porttitor ipsum, quis ullamcorper leo. 
                    Mauris eu purus nibh. "
                    value={bioText}
                    onChange={handleBioChange}
                  ></textarea>
                </div>
                <div className="textcount">
                  <p>{` ${remainingWords}  Characters left`}</p>
                </div>
              </div>
            </div>
          </div>
        )}
        {activeSection === "Address" && (
          <div className="addresscontent">
            <div className="coutryname">
              <p>Country</p>
              <input type="text" placeholder="United State of America" />
            </div>
            <div className="coutryname">
              <p>City/State</p>
              <input type="text" placeholder="California, USA" />
            </div>
            <div className="coutryname">
              <p>Postal Code </p>
              <input type="text" placeholder="ERT 62574" />
            </div>
          </div>
        )}
        {activeSection === "Social Media" && (
          <div className="socialmedia">
           <div className="accountname">
              <p>Facebook</p>
              <input type="text" placeholder="www.facebook.com" />
            </div>
            <div className="accountname">
              <p>Instagram</p>
              <input type="text" placeholder="www.instagram.com" />
            </div>
            <div className="accountname">
              <p>X </p>
              <input type="text" placeholder="www.x.com" />
            </div>
            <div className="accountname">
              <p>Linkedin</p>
              <input type="text" placeholder="www.linkedin.com" />
            </div>
          </div>
        )}
        </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default EditProfile;
